import React from "react";
import './Body5.css';
import Box2 from "./Box2";
import {Link} from "react-router-dom"
import picture200 from './source/picture200.webp'
import picture205 from './source/picture205.webp'
import picture215 from './source/picture215.webp'
import picture220 from './source/picture220.webp'
import picture230 from './source/picture230.webp'
import picture250 from './source/picture250.webp'
import picture260 from './source/picture260.webp'
import picture270 from './source/picture270.webp'
import picture280 from './source/picture280.webp'
import picture290 from './source/picture290.webp'
import picture300 from './source/picture300.webp'
import picture310 from './source/picture310.webp'
import picture320 from './source/picture320.webp'
import picture330 from './source/picture330.webp'
import picture335 from './source/picture335.webp'
import picture342 from './source/picture342.webp'
import picture366 from './source/picture366.webp'
import picture372 from './source/picture372.webp'
import picture376 from './source/picture376.webp'
import picture386 from './source/picture386.webp'



function Body5() {

  return (
    <div className="body5">
      <div className="body5-box1">
        <div className="body5-box2">
          <div className="body5-box3">Projekty</div>
          <div className="body5-box5"><div className="body5-box4"></div></div>
          <div className="body5-box6">
          <Link to="/PageProjektyBody7"><Box2 ImgBox2={picture200} NadpisBox2='Kudlovice'/></Link>
          <Link to="/PageProjektyBody8"><Box2 ImgBox2={picture205} NadpisBox2='Zlín'/></Link>
          <Link to="/PageProjektyBody9"><Box2 ImgBox2={picture215} NadpisBox2='Hluk'/></Link>
          <Link to="/PageProjektyBody10"><Box2 ImgBox2={picture220} NadpisBox2='Moravský Písek'/></Link>
          <Link to="/PageProjektyBody11"><Box2 ImgBox2={picture230} NadpisBox2='Hluk'/></Link>
          <Link to="/PageProjektyBody13"><Box2 ImgBox2={picture250} NadpisBox2='Buchlovice'/></Link>
          <Link to="/PageProjektyBody14"><Box2 ImgBox2={picture260} NadpisBox2='Staré město'/></Link>
          <Link to="/PageProjektyBody15"><Box2 ImgBox2={picture270} NadpisBox2='Zlechov'/></Link>
          <Link to="/PageProjektyBody16"><Box2 ImgBox2={picture280} NadpisBox2='Kudlovice'/></Link>
          <Link to="/PageProjektyBody17"><Box2 ImgBox2={picture290} NadpisBox2='Hluk'/></Link>
          <Link to="/PageProjektyBody18"><Box2 ImgBox2={picture300} NadpisBox2='Zlín'/></Link>
          <Link to="/PageProjektyBody19"><Box2 ImgBox2={picture310} NadpisBox2='Kudlovice'/></Link>
          <Link to="/PageProjektyBody20"><Box2 ImgBox2={picture320} NadpisBox2='Malenovice'/></Link>
          <Link to="/PageProjektyBody21"><Box2 ImgBox2={picture330} NadpisBox2='Staré Město'/></Link>
          <Link to="/PageProjektyBody22"><Box2 ImgBox2={picture335} NadpisBox2='Halenkovice'/></Link>
          <Link to="/PageProjektyBody23"><Box2 ImgBox2={picture342} NadpisBox2='Ořechov'/></Link>
          <Link to="/PageProjektyBody24"><Box2 ImgBox2={picture366} NadpisBox2='Zlechov'/></Link>
          <Link to="/PageProjektyBody25"><Box2 ImgBox2={picture372} NadpisBox2='Kudlovice Dolina'/></Link>
          <Link to="/PageProjektyBody26"><Box2 ImgBox2={picture376} NadpisBox2='Ostrožská Nová Ves'/></Link>
          <Link to="/PageProjektyBody27"><Box2 ImgBox2={picture386} NadpisBox2='Říkovice u Přerova'/></Link>
          </div>
        </div> 
      </div> 
    </div>
  );
}

export default Body5;
